<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M23 23V0H0.0412676L0 23H23ZM5.39374 0.744141H17.1447L22.2036 22.3884H18.984L14.5934 4.32957H7.65101L3.72017 22.3884H0.708984L5.39374 0.744141ZM14.0109 7.82764H8.15608L5.22852 22.3008H17.3972L14.0109 7.82764ZM8.78003 19.7212L13.8815 10.3198H8.82171L7.69233 15.3922L10.7028 13.2932L6.3125 21.3385H16.2653L14.9687 16.0044L8.78003 19.7212ZM22.2484 0.744141H19.2793L22.2484 14.1673V0.744141ZM0.792969 0.744141H3.76248L0.792969 14.1673V0.744141Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgZONTAMyZonta',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>